/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on May 29, 2026 by hoarfroster
 *
 */

import { useTitle } from '@utils/title';
import I18N from '@utils/i18n.base';
import { Link } from 'react-router';

export default function NotFoundPage() {
    useTitle(I18N.app.notFound);

    return (
        <>
            <div className="from-primary/8 to-primary/4 flex h-72 flex-col items-center justify-end bg-gradient-to-b lg:h-80 xl:h-96">
                <div className="mx-16 flex items-end justify-center">
                    <div className="mr-16 pb-16 lg:w-144 xl:mr-32 xl:w-160">
                        <h1 className="mb-8 text-4xl font-black lg:text-5xl xl:text-6xl">{I18N.app.notFoundWelcome}</h1>
                        <p className="text-lg leading-7 lg:text-xl lg:leading-9 xl:text-2xl">
                            {I18N.app.notFoundDescription}
                        </p>
                    </div>
                    <img src="/penguin.svg" alt="Penguin" className="hidden w-36 md:block lg:w-48 xl:w-56" />
                </div>
            </div>
            <div className="mx-auto mt-16 mb-8">
                <div className="flex flex-wrap space-x-4">
                    <Link
                        to="/cooking/recipes"
                        className="m-4 min-w-72 flex-1 rounded-lg border border-gray-300 px-8 py-6 duration-100 hover:shadow-xl dark:border-gray-700"
                    >
                        <h4 className="mb-4 flex items-center text-2xl font-bold">
                            <span className="material-symbols-rounded mr-4 text-4xl!">cooking</span>{' '}
                            {I18N.cooking.cooking}
                        </h4>
                        <p className="mb-8 text-lg">{I18N.app.homeCookingDescription}</p>
                    </Link>
                    <Link
                        to="/note"
                        className="m-4 min-w-72 flex-1 rounded-lg border border-gray-300 px-8 py-6 duration-100 hover:shadow-xl dark:border-gray-700"
                    >
                        <h4 className="mb-4 flex items-center text-2xl font-bold">
                            <span className="material-symbols-rounded mr-4 text-4xl!">description</span>{' '}
                            {I18N.note.title}
                        </h4>
                        <p className="mb-8 text-lg">{I18N.app.homeNoteDescription}</p>
                    </Link>
                </div>
            </div>
        </>
    );
}
